var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.isAllSelected
      ? _c("div", { staticClass: "well well-sm" }, [
          _vm._v("\n        You have selected "),
          _c("strong", [_vm._v(_vm._s(_vm.totalSelectedItems))]),
          _vm._v(
            " " + _vm._s(_vm.verboseOperationName) + " on the page.\n        "
          ),
          _c(
            "button",
            {
              staticClass: "btn btn-outline btn-outline-info",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("select-all-items")
                },
              },
            },
            [
              _vm._v("\n            Select all "),
              _c("strong", [_vm._v(_vm._s(_vm.totalCount))]),
              _vm._v(
                " of your " + _vm._s(_vm.verboseOperationName) + "?\n        "
              ),
            ]
          ),
        ])
      : _c(
          "div",
          { staticClass: "well well-sm" },
          [
            _vm.hasMorePages
              ? [
                  _vm._v("\n            All of your "),
                  _c("strong", [_vm._v(_vm._s(_vm.totalSelectedItems))]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.verboseOperationName) +
                      " have been selected.\n            "
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline btn-outline-info",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("clear-selections")
                        },
                      },
                    },
                    [_vm._v("\n                Clear selections\n            ")]
                  ),
                ]
              : [
                  _vm._v("\n            You have selected "),
                  _c("strong", [_vm._v(_vm._s(_vm.totalSelectedItems))]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.verboseOperationName) +
                      ". There are no more " +
                      _vm._s(_vm.verboseOperationName) +
                      " to select.\n        "
                  ),
                ],
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }